/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blank_Frames_DescriptionInputs */

const en_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure and insert blank frames between captions`)
};

const fr_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurer et insérer des images vides entre les sous-titres`)
};

const de_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren und einfügen Sie leere Rahmen zwischen den Untertiteln.`)
};

const it_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configura e inserisci cornici vuote tra le didascalie`)
};

const ru_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройте и вставьте пустые рамки между подписями.`)
};

const es_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurar e insertar marcos en blanco entre subtítulos`)
};

const zh_cn2_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置并在字幕之间插入空白帧。`)
};

const ja_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプション間に空白フレームを設定して挿入する`)
};

const hi_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैप्शन के बीच खाली फ्रेम कॉन्फ़िगर करें और डालें`)
};

const pt_pt2_blank_frames_description = /** @type {(inputs: Blank_Frames_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure e insira quadros em branco entre as legendas.`)
};

/**
* | output |
* | --- |
* | "Configure and insert blank frames between captions" |
*
* @param {Blank_Frames_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const blank_frames_description = /** @type {((inputs?: Blank_Frames_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blank_Frames_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_blank_frames_description(inputs)
	if (locale === "de") return de_blank_frames_description(inputs)
	if (locale === "it") return it_blank_frames_description(inputs)
	if (locale === "ru") return ru_blank_frames_description(inputs)
	if (locale === "es") return es_blank_frames_description(inputs)
	if (locale === "zh-CN") return zh_cn2_blank_frames_description(inputs)
	if (locale === "ja") return ja_blank_frames_description(inputs)
	if (locale === "hi") return hi_blank_frames_description(inputs)
	if (locale === "pt-PT") return pt_pt2_blank_frames_description(inputs)
	return en_blank_frames_description(inputs)
});